<template>
  <div class="view-sales-recovery">
    <h3>Vendas perdidas</h3>
    <bp-table-header
      :total="pagination.count"
      @refresh="refresh"
      @open-filter="filter = true"
    >
      <template #input>
        <bp-input
          v-model="filters.search"
          size="md"
          placeholder="Buscar"
          pre-icon="fa-light fa-search"
          :delay="300"
          @change="refresh"
        />
      </template>
      <template #date-picker>
        <bp-date-picker v-model="filters.dates" @input="refresh" />
      </template>
      <template #filter>
        <responsive-modal v-model="filter" size="lg" title="Filtrar">
          <sale-recovery-filter
            v-model="filters"
            @input="refresh"
            @close="filter = false"
          />
        </responsive-modal>
      </template>
      <template #buttons v-if="$permissions.hasPermission('exportar-vendas')">
        <bp-export-button
          filename="sales_recovery"
          action="sale/exportInitiateCheckout"
          :filters="getFilters"
          :disabled="!initiateCheckout.length"
        />
      </template>
    </bp-table-header>

    <bp-data-table
      class="my-7"
      :loading="loading"
      :columns="columns"
      :data="initiateCheckout"
    />

    <bp-paginator
      v-model="page"
      :pagination="pagination"
      @change-page="dispatch"
    />
  </div>
</template>
<script>
import SaleRecoveryFilter from "@/components/sale/SaleRecoveryFilter.vue";
import { formatDate, formatDocument } from "@/functions/formatting";
import { clearObject } from "@/functions/helpers";

import { mapState } from "vuex";

export default {
  components: { SaleRecoveryFilter },
  data() {
    return {
      loading: false,
      filter: false,
      filters: {
        product_id: [],
        dates: [],
        search: ""
      },
      page: 1,
      columns: [
        {
          name: "Data",
          field: "created_at",
          transform: formatDate
        },
        {
          name: "Comprador",
          field: "name"
        },
        {
          name: "E-mail",
          field: "email",
          copy: true,
          message: "E-mail copiado"
        },
        {
          name: "Telefone",
          field: "phone",
          copy: true,
          message: "Telefone copiado"
        },
        {
          name: "Documento",
          field: "document",
          transform: formatDocument
        },
        {
          name: "Link do checkout",
          field: "product",
          transform: this.getLink,
          type: "link",
          copy: false
        }
      ]
    };
  },
  computed: {
    ...mapState("sale", ["initiateCheckout", "pagination"]),
    ...mapState("product", ["products"])
  },
  mounted() {
    this.dispatch();
    this.$store.dispatch("product/get", { limit: 100 });
  },
  methods: {
    getLink(_, item) {
      const queryString = new URLSearchParams(
        clearObject(item.query_params)
      ).toString();
      const product = this.products.find(p => p.id == item.product);
      if (!product) return null;
      return `${product.url}?${queryString}`;
    },
    getFilters() {
      const { search, product_id } = this.filters;
      const [created_at_after, created_at_before] = this.filters.dates;
      return clearObject({
        search,
        product_id,
        created_at_after,
        created_at_before
      });
    },

    refresh() {
      this.page = 1;
      this.dispatch();
    },
    dispatch(offset = 0) {
      const params = { offset, ...this.getFilters() };

      this.loading = true;
      this.$store.dispatch("sale/getInitiateCheckout", params).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
